import React from "react";
import Bubble from "./Bubble";
import BubbleHolder from "./BubbleHolder";

const BubbleRows = ({
  noOfCols,
  noOfRows,
  middleCol,
  middleRow,
  middleBubbleColSpan,
  middleBubbleRowSpan,
  cellIndexContent,
  onClickedCell,
  selection,
  shouldAnimate,
  onClickedCancelCell,
  isWithinSubCategory,
}) => {
  const maxNoOfCells = 17; //noOfCols * noOfRows - (middleBubbleColSpan * middleBubbleRowSpan - 1);
  const BubbleCols = ({
    isMiddleRow,
    rowNo,
    onClickedCell,
    selection,
    shouldAnimate,
    onClickedCancelCell,
    //   noOfCols,
    //   middleCol,
    //   middleBubbleColSpan,
    //   middleBubbleRowSpan,
    //   cellIndexContent,
    //   maxNoOfCells,
  }) => {
    let startCellNo = (rowNo - 1) * noOfCols;
    const cols = [];
    for (let i = 0; i < noOfCols; i++) {
      let className = "";
      let cellNo = startCellNo + (i + 1);
      let cellContent = cellIndexContent.items &&
        cellIndexContent.items[cellNo] && { ...cellIndexContent.items[cellNo] };
      //   console.log(
      //     "cellContent",
      //     cellContent,
      //     "cellIndexContent",
      //     cellIndexContent
      //   );
      let isMiddleBubble = isMiddleRow && i + 1 === middleCol;
      // if (isMiddleBubble) {
      //   className = `col-span-${middleBubbleColSpan} row-span-${middleBubbleRowSpan}`;
      // }

      let isSelected =
        selection &&
        selection[cellContent && cellContent.mainOptionSlug] &&
        selection[cellContent.mainOptionSlug][cellContent.slug];

      // console.log(
      //   "isSelected test",
      //   selection && selection[cellContent?.mainOptionSlug],
      //   cellContent?.slug,
      //   selection
      // );

      if (!isSelected) {
        if (selection && selection[cellContent?.slug] && cellNo !== 9) {
          //Ensure that isSelected is only true if there are actually preferred options set.

          let keys = Object.keys(selection[cellContent.slug]);
          keys = keys.filter((key) => {
            return key != "additionalQuestions";
          });
          if (keys.length > 0) {
            isSelected = true;
          }

          // isSelected = true;

          // console.log(
          //   "cellContent.slug",
          //   cellContent.slug,
          //   "Object.keys(selection[cellContent.slug])",
          //   Object.keys(selection[cellContent.slug])
          // );
        }
        console.log("js isSelected", isSelected, cellContent, selection);
      }

      if (isSelected && !isWithinSubCategory) {
        let keys = Object.keys(selection[cellContent.slug]);
        keys = keys.filter((key) => {
          return key != "additionalQuestions";
        });
        cellContent.desc = `(${keys.length} preference${
          keys.length > 1 ? "s" : ""
        })`;
      }

      if (cellNo <= maxNoOfCells) {
        className =
          className +
          " " +
          (cellContent
            ? "opacity-100 inline-block w-1/2 md:w-full"
            : "hidden md:block opacity-0 pointer-events-none");
        if (cellNo === 9) {
          className = className + " hidden md:block";
        }
        cols.push(
          <BubbleHolder
            className={`${className} ${
              isMiddleBubble
                ? `col-span-${middleBubbleColSpan} row-span-${middleBubbleRowSpan}`
                : ""
            }`}
            key={rowNo + "_" + i + 1}
          >
            <Bubble
              rowNo={rowNo}
              colNo={i + 1}
              isMiddleBubble={isMiddleBubble}
              bgImg={
                isWithinSubCategory &&
                isMiddleBubble &&
                'url("/images/bubble-bgs/orange.jpg")'
              }
              cellNo={cellNo}
              style={{
                left: cellContent ? cellContent.left : null,
                right: cellContent ? cellContent.right : null,
                top: cellContent ? cellContent.top : null,
                bottom: cellContent ? cellContent.bottom : null,
              }}
              onClick={() => {
                cellContent && onClickedCell && onClickedCell({ cellNo });
              }}
              isSelected={isSelected}
              shouldAnimate={shouldAnimate}
              onClickedCancel={
                !isWithinSubCategory
                  ? () => {
                      onClickedCancelCell && onClickedCancelCell({ cellNo });
                    }
                  : null
              }
            >
              {/* {cellNo} out of {maxNoOfCells} */}
              {cellContent?.title ? (
                <div>
                  {cellNo === 9 ? (
                    <h1 className="px-[30px] leading-tight text-[4vw] break-words font-black">
                      {cellContent.title}
                    </h1>
                  ) : (
                    <h4 className="px-[30px] break-words md:text-[1.2vw]">
                      {cellContent.title}
                    </h4>
                  )}
                  <p className="text-sm font-light text-white">
                    {cellContent.desc}
                  </p>
                  {/* {cellContent?.body && <div>{cellContent.body}</div>} */}
                </div>
              ) : null}
            </Bubble>
          </BubbleHolder>
        );
      }
    }
    return cols;
  };
  const rows = [];
  for (let i = 0; i < noOfRows; i++) {
    let isMiddleRow = i + 1 === middleRow;
    rows.push(
      <BubbleCols
        isMiddleRow={isMiddleRow}
        rowNo={i + 1}
        noOfCols={noOfCols}
        middleCol={middleCol}
        middleBubbleColSpan={middleBubbleColSpan}
        middleBubbleRowSpan={middleBubbleRowSpan}
        cellIndexContent={cellIndexContent}
        maxNoOfCells={maxNoOfCells}
        onClickedCell={onClickedCell}
        selection={selection}
        key={"row_" + (i + 1)}
        shouldAnimate={shouldAnimate}
        onClickedCancelCell={onClickedCancelCell}
      />
    );
  }
  return rows;
};

export default BubbleRows;
